<template>
  <el-dialog title="预留" :visible.sync="dialogVisible" width="24%" top="20vh">
    <el-form
      status-icon
      ref="ruleForm"
      class="demo-ruleForm"
    >
      <el-form-item label="选择时间" prop="pass">
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="选择报备" prop="pass">
        <el-select style="width:100%" v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="small-btn btn-bor"
        size="small"
        @click="dialogVisible = false"
        >取 消</el-button
      >
      <el-button
        class="small-btn bgC"
        size="small"
        type="primary"
        @click="submit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "reserveDg",
  data() {
    return {
      dialogVisible: false,
      value1: '',
      options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }],
        value: ''
    };
  },
  methods: {
    //   提交按钮
    submit() {
      this.$emit("onreserve", this.ruleForm);
    },
  },
};
</script>

<style>
.el-form-item__label {
  padding: 0 !important;
}
.el-form-item {
  margin-bottom: 0 !important;
  padding: 5px 30px;
}
.el-dialog__body {
  padding-top: 0px;
}
.el-dialog {
  border-radius: 8px;
}
.el-dialog__footer {
  padding-top: 0;
  text-align: center;
}
.small-btn:hover {
  opacity: 0.8 !important;
}
.small-btn:active {
  opacity: 0.9 !important;
}
</style>